














import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class UpdateIcon extends Vue {
    @Prop({ default: "var(--ppdw-primary)" }) fill: string;
}
